
export default {
  namespaced: true,
  state: () => ({
    filterDeviceType: 'desktop',
    filterQuery: '',
    filterSubjectsQuery: '',
  }),
  mutations: {
    setFilterDeviceType (state, filterDeviceType) {
      state.filterDeviceType = filterDeviceType
    },
    setFilterQuery (state, filterQuery) {
      state.filterQuery = filterQuery
    },
    setFilterSubjectsQuery (state, filterSubjectsQuery) {
      state.filterSubjectsQuery = filterSubjectsQuery
    }
  },
}